import { PencilAltIcon } from 'components/icons/PencilAltIcon';
import { useLocale } from 'containers/App/LocaleContext';
import { useState } from 'react';
import type { FC } from 'react';
import { GraphSnapshotCreation } from '../GraphSnapshotCreation/GraphSnapshotCreation';
import { GraphToolbarButton } from './GraphToolbarButton';

export interface Props {
  disabled: boolean;
}

export const GraphToolbarSnapshotCreation: FC<Props> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const {
    canvasGraph: {
      graphToolbar: { buttons: msgButtons },
    },
  } = useLocale();

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      {open && <GraphSnapshotCreation onClose={handleClose} />}
      <GraphToolbarButton
        disabled={props.disabled}
        disabledTitle={msgButtons.modifySnapshot}
        onClick={handleOpen}
        title={msgButtons.modifySnapshot}
      >
        <PencilAltIcon
          title={msgButtons.modifySnapshot}
          width={16}
          height={16}
        />
      </GraphToolbarButton>
    </>
  );
};
